import React, { useEffect } from 'react';
import CustomSelect from '../../components/CustomSelect';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { SingleCommonType } from '../../types';
import { influencersTypePlaceholder } from '../../constants/placeholder';
import { commonBackInfo } from '../../utils';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import { NO_DATE } from '@/pages/opinion/constants';
import {
  influencersTypeOptions,
  influencersTypeMap,
} from '../../constants/influencersType';
import './index.scss';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function InfluencersTypeSelect({
  onChange,
  defaultValue,
  defaultKey,
  filterValue,
  lang,
}: SingleCommonType) {
  const {
    selects: influencersTypeSelects,
    setSelects: setInfluencersTypeSelects,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'officials',
    options: influencersTypeOptions.map((item) => item.value),
  });

  const { formatOptionsMessage, formatMessage } = useLanguage();

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  useEffect(() => {
    const [text, isAll] = getButtonElement();
    onChange?.(
      'officials',
      commonBackInfo(
        { officials: influencersTypeSelects },
        { [defaultKey]: text },
        { isAll, needChangeEntity: true },
      ),
    );
  }, [influencersTypeSelects, formatMessage]);

  return (
    <div className={`influencers-type-select-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        placeholderText={influencersTypePlaceholder[lang]}
        onClear={() => setInfluencersTypeSelects([])}
        buttonItemRender={(item: string) =>
          formatMessage({ id: influencersTypeMap[item] || NO_DATE.EMPTY })
        }
        pointKey={FilterButtonPoint.influencersType}
        boxClassName="influencers-type-select-box"
        selectOptionsInfo={[influencersTypeSelects, setInfluencersTypeSelects]}
        options={formatOptionsMessage(influencersTypeOptions)}
      ></CustomSelect>
    </div>
  );
}
